import React, { useState } from "react";
import ApiCall from "../../constants/Api";
import { helpAxios } from "../../helpers/helpAxios";
import { errorHandler } from "../ErrorHandler";
import Swal from "sweetalert2";
import { successMsg } from "../SuccessHandler";
import ReactInputMask from "react-input-mask";
import ErrorCodes from "../../constants/ErrorCodes";
import SiteConfig from "../../constants/SiteConfig";
import { useUpdateFunctions } from "../../functions";
import ConfirmDialog from "../utilities/ConfirmDialog";

const Results = ({
  raceInfo,
  raceSelected,
  resultsList,
  setResultsList,
  entries,
  userInfo,
  trackCode,
  setSessionNoLongerExists,
  readOnlyResults,
  insertOrViewResults,
  setInsertOrViewResults,
  isDisabled,
}) => {
  let Result3 = [],
    buttonsResults,
    insertOrViewResultsBtn,
    ResultExoticView = [];
  const { updateResultsInfo } = useUpdateFunctions();
  const filteredEntries = entries.filter((entry) => entry.FinishPos !== -1);
  const [errorsPTF, setErrorsPTF] = useState(false);

  //Onchange de la tabla de éxoticas
  const handleChangeExotic = (e, maxAttributeValue) => {
    const resultsChange = { ...resultsList };

    let wagertype = e.target.getAttribute("datawagertype");

    let post = parseInt(
      e.target.id
        .replace(new RegExp("(" + wagertype + ")", "gi"), "")
        .replace(/\s{2,}/g, "")
        .replace(/^\D+/g, ""),
      10
    );

    if (!resultsChange[wagertype]) resultsChange[wagertype] = [];
    if (!resultsChange[wagertype][post]) resultsChange[wagertype][post] = [];

    if (e.target.name === "Correct") {
      if (parseInt(e.target.value) > maxAttributeValue) {
        resultsChange[wagertype][post][e.target.name] = maxAttributeValue;
      } else if (parseInt(e.target.value) < 2) {
        resultsChange[wagertype][post][e.target.name] = 2;
      } else {
        resultsChange[wagertype][post][e.target.name] = parseInt(
          e.target.value.replace(/\D/g, "")
        );
      }
    } else {
      if (e.target.name === "Selections") {
        resultsChange[wagertype][post][e.target.name] = e.target.value.replace(
          /[^\d/*-]|\.(?=.*\.)/g,
          ""
        );
      } else {
        resultsChange[wagertype][post][e.target.name] = e.target.value;
      }
    }

    if (e.target.name === "PTF") {
      resultsChange[wagertype][post][e.target.name] = e.target.value.replace(
        /\s-\s/g,
        "-"
      );
    }

    setResultsList(resultsChange);
  };

  //ADD NEW WAGER TYPE
  const newExoticResult = (poolType, wagerType) => {
    let newResult = {};
    const newItems = resultsList;
    newResult.Selections = "";
    newResult.Payout = "";
    newResult.New = true;
    newResult.PoolType = poolType;
    newItems[wagerType].push(newResult);
    setResultsList({ ...newItems });
  };

  //Deletes the information entered in the exotics from the results.
  const DeleteResults = (poolType, wagerType) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.value) {
        resultsList[wagerType][poolType].Selections = "";
        resultsList[wagerType][poolType].Payout = "";
        resultsList[wagerType][poolType].Correct = "";
        setResultsList({ ...resultsList });
      }
    });
  };

  //WAGER TYPES RESULTS (Tabla Win Place Show)
  const resultsExoticTable = (wagerType, data) => {
    let table = [],
      tablePicks = [];
    const wagerTypeLabel =
      wagerType.charAt(0).toUpperCase() + wagerType.slice(1);
    if (data && data.length !== 0) {
      if (wagerType.includes("Double")) {
        data.forEach((element, i) => {
          tablePicks.push(
            <div
              className="form-row mb-2"
              key={`${element.PoolType}-${element.Position}-${i}`}
            >
              <label
                htmlFor="staticEmail"
                className="col-sm-1 lead mt-2 mr-4"
                style={{ fontSize: "16px", fontWeight: "bold" }}
                key={"lbl" + i}
              >
                {wagerTypeLabel}
              </label>
              <div
                className="col-sm-3"
                key={"wtd" + i}
                style={{
                  verticalAlign: "middle",
                  textAlign: "center",
                }}
              >
                {insertOrViewResults ? (
                  <input
                    type="text"
                    autoComplete="off"
                    placeholder="Entries"
                    className="form-control results-font "
                    key={"E" + i}
                    id={"E" + wagerType + i}
                    datawagertype={wagerType}
                    name="Selections"
                    value={element.Selections || ""}
                    onChange={handleChangeExotic}
                    style={{
                      backgroundColor: "transparent",
                      border: "none",
                      textAlign: "center",
                    }}
                  />
                ) : (
                  <div className="mt-2">{element.Selections || ""}</div>
                )}
              </div>
              <div
                className="input-group mr-1"
                style={{ width: "150px" }}
                key={"pd" + i}
              >
                <div
                  className="input-group-prepend"
                  style={{ backgroundColor: "transparent" }}
                  key={"pld" + i}
                >
                  <span
                    className="input-group-text"
                    id="inputGroup-sizing-default"
                    style={{
                      border: "none",
                      fontWeight: "bold",
                      color: "#bfbfbf",
                    }}
                  >
                    $2
                  </span>
                </div>
                {insertOrViewResults ? (
                  <input
                    type="number"
                    autoComplete="off"
                    placeholder="Payout"
                    className="form-control results-font"
                    key={"P" + i}
                    id={"P" + wagerType + i}
                    datawagertype={wagerType}
                    name="Payout"
                    value={element.Payout}
                    onChange={handleChangeExotic}
                    style={{
                      border: "none",
                      backgroundColor: "transparent",
                    }}
                  />
                ) : (
                  <div className="mt-2">{element.Payout}</div>
                )}
              </div>
              {insertOrViewResults && (
                <div className="col input-group" key={"bd" + i}>
                  <i
                    className="fas fa-plus fa-bold mr-3 mt-2"
                    style={{ color: "#28A745" }}
                    onClick={() => {
                      newExoticResult(data[0].PoolType, wagerType);
                    }}
                    key={"btnNewD" + i}
                  ></i>

                  <i
                    className="fas fa-eraser fa-bold mt-2 mr-3 mr-3"
                    style={{ color: "#DC3445" }}
                    onClick={() => DeleteResults(i, wagerType)}
                    key={"btnDelD" + i}
                  ></i>
                </div>
              )}
            </div>
          );
        });
        table.push(
          <div className="scroll-vertical" key={`scroll-${wagerType}`}>
            {tablePicks}
          </div>
        );
      } else {
        if (wagerType.includes("Pick")) {
          const match = wagerType.match(/\d+$/);
          const numeroWagerType = match ? parseInt(match[0], 10) : null;
          const maxAttributeValue = numeroWagerType ? numeroWagerType : "";
          let mask = "99"; // Máscara predeterminada para 2 dígitos

          if (maxAttributeValue && maxAttributeValue > 1) {
            mask = Array.from({ length: maxAttributeValue }, () => "99").join(
              "-"
            );
          }

          data.forEach((element, i) => {
            /*This const saves the replacement of the dashes inside element.PTF by whitespace, 
              so that they are correctly displayed according to the expected mask in the ReactInputMask*/
            const adjustedPTFValue = element.PTF
              ? element.PTF.split("-").join(" ")
              : "";

            tablePicks.push(
              <div className="form-row mb-2" key={i}>
                <label
                  htmlFor="staticEmail"
                  className="col-sm-1 lead mt-2 mr-4"
                  style={{ fontSize: "16px", fontWeight: "bold" }}
                  key={"lblp" + i}
                >
                  {wagerTypeLabel}
                </label>
                <div
                  className="col-sm-3"
                  key={"wtp" + i}
                  style={{
                    textAlign: "center",
                    verticalAlign: "middle",
                  }}
                >
                  {insertOrViewResults ? (
                    <input
                      type="text"
                      autoComplete="off"
                      placeholder="Entries"
                      className="form-control results-font "
                      key={"E" + i}
                      id={"E" + wagerType + i}
                      datawagertype={wagerType}
                      name="Selections"
                      value={element.Selections || ""}
                      onChange={handleChangeExotic}
                      style={{
                        backgroundColor: "transparent",
                        border: "none",
                        textAlign: "center",
                      }}
                    />
                  ) : (
                    <div className="mt-2">{element.Selections || ""}</div>
                  )}
                </div>
                <div
                  className="input-group mr-1"
                  style={{ width: "150px" }}
                  key={"pp" + i}
                >
                  <div
                    className="input-group-prepend"
                    style={{ backgroundColor: "transparent" }}
                    key={"payld" + i}
                  >
                    <span
                      className="input-group-text"
                      id="inputGroup-sizing-default"
                      style={{
                        border: "none",
                        fontWeight: "bold",
                        color: "#bfbfbf",
                      }}
                    >
                      $2
                    </span>
                  </div>
                  {insertOrViewResults ? (
                    <input
                      type="number"
                      autoComplete="off"
                      placeholder="Payout"
                      className="form-control results-font"
                      key={"P" + i}
                      id={"P" + wagerType + i}
                      datawagertype={wagerType}
                      name="Payout"
                      value={element.Payout}
                      onChange={handleChangeExotic}
                      style={{
                        border: "none",
                        backgroundColor: "transparent",
                      }}
                    />
                  ) : (
                    <div className="mt-2">{element.Payout}</div>
                  )}
                </div>
                <div
                  className="mr-1 mt-1"
                  key={"cp" + i}
                  style={{
                    textAlign: "center",
                    verticalAlign: "middle",
                    width: "90px",
                  }}
                >
                  {insertOrViewResults ? (
                    <input
                      type="number"
                      autoComplete="off"
                      placeholder="Correct"
                      className="form-control results-font "
                      key={"E" + i}
                      id={"E" + wagerType + i}
                      datawagertype={wagerType}
                      name="Correct"
                      value={element.Correct || ""}
                      onChange={(e) => handleChangeExotic(e, maxAttributeValue)}
                      style={{
                        backgroundColor: "transparent",
                        border: "none",
                        textAlign: "center",
                      }}
                      min="2"
                      max={maxAttributeValue}
                    />
                  ) : (
                    <div className="mt-2">{element.Correct || ""}</div>
                  )}
                </div>
                <div
                  className="mr-1 mt-1 col-12 col-sm-6 col-md-4 col-lg-2"
                  key={"ptfp" + i}
                  style={{
                    textAlign: "center",
                    verticalAlign: "middle",
                  }}
                >
                  {insertOrViewResults ? (
                    <ReactInputMask
                      className="form-control results-font"
                      mask={mask}
                      maskChar=" "
                      id={"E" + wagerType + i}
                      datawagertype={wagerType}
                      name="PTF"
                      value={adjustedPTFValue || ""}
                      onChange={handleChangeExotic}
                      placeholder="PTF"
                      style={{
                        backgroundColor: "transparent",
                        border: "none",
                        textAlign: "center",
                      }}
                    />
                  ) : (
                    <div className="mt-2">{element.PTF || ""}</div>
                  )}
                </div>
                {insertOrViewResults && (
                  <div className="col input-group" key={"bd" + i}>
                    <i
                      className="fas fa-plus fa-bold mr-2 mt-2"
                      style={{ color: "#28A745" }}
                      onClick={() => {
                        newExoticResult(data[0].PoolType, wagerType);
                      }}
                      key={"btnNewD" + i}
                    ></i>

                    <i
                      className="fas fa-eraser fa-bold mt-2"
                      style={{ color: "#DC3445" }}
                      onClick={() => DeleteResults(i, wagerType)}
                      key={"btnDelD" + i}
                    ></i>
                  </div>
                )}
              </div>
            );
          });
          table.push(<div className="scroll-vertical">{tablePicks}</div>);
        } else {
          data.forEach((element, i) => {
            const uniqueKey = `${wagerType}-${element.PoolType || ""}-${
              element.Position || i
            }`;
            table.push(
              <div className="form-row mb-2" key={uniqueKey}>
                <label
                  htmlFor="staticEmail"
                  className="col-sm-1 lead mt-2 mr-4"
                  style={{ fontSize: "16px", fontWeight: "bold" }}
                  key={"lblE" + i}
                >
                  {wagerTypeLabel}
                </label>
                <div
                  className="col-sm-3"
                  key={"ee" + i}
                  style={{
                    textAlign: "center",
                    verticalAlign: "middle",
                  }}
                >
                  {insertOrViewResults ? (
                    <input
                      type="text"
                      autoComplete="off"
                      placeholder="Entries"
                      className="form-control results-font "
                      key={"E" + i}
                      id={"E" + wagerType + i}
                      datawagertype={wagerType}
                      name="Selections"
                      value={element.Selections || ""}
                      onChange={handleChangeExotic}
                      style={{
                        backgroundColor: "transparent",
                        border: "none",
                        textAlign: "center",
                      }}
                    />
                  ) : (
                    <div className="mt-2">{element.Selections || ""}</div>
                  )}
                </div>
                <div
                  className="input-group mr-1"
                  style={{ width: "150px" }}
                  key={"pe" + i}
                >
                  <span
                    className="input-group-text"
                    id="inputGroup-sizing-default"
                    style={{
                      border: "none",
                      fontWeight: "bold",
                      color: "#bfbfbf",
                    }}
                  >
                    $2
                  </span>
                  {insertOrViewResults ? (
                    <input
                      type="number"
                      placeholder="Payout"
                      autoComplete="off"
                      className="form-control results-font"
                      key={"P" + i}
                      id={"P" + wagerType + i}
                      datawagertype={wagerType}
                      name="Payout"
                      value={element.Payout}
                      onChange={handleChangeExotic}
                      style={{
                        backgroundColor: "transparent",
                        border: "none",
                      }}
                    />
                  ) : (
                    <div className="mt-2">{element.Payout}</div>
                  )}
                </div>
                {insertOrViewResults && (
                  <div className="col input-group" key={"bd" + i}>
                    <i
                      className="fas fa-plus fa-bold mr-3 mt-2"
                      style={{ color: "#28A745" }}
                      onClick={() => {
                        newExoticResult(data[0].PoolType, wagerType);
                      }}
                      key={"btnNewD" + i}
                    ></i>

                    <i
                      className="fas fa-eraser fa-bold mt-2 mr-3 mr-3"
                      style={{ color: "#DC3445" }}
                      onClick={() => DeleteResults(i, wagerType)}
                      key={"btnDelD" + i}
                    ></i>
                  </div>
                )}
              </div>
            );
          });
        }
      }
    }

    return table;
  };

  const setEmptyResult = (poolType, wagerType) => {
    setResultsList({
      ...resultsList,
      [wagerType]: [
        {
          Selections: "",
          Payout: "",
          New: true,
          PoolType: poolType,
        },
      ],
    });
  };

  //WAGER TYPES RESULTS (Exotic table)
  if (raceInfo && resultsList.length !== 0) {
    if (raceInfo.Exacta) {
      if (resultsList.Exacta && resultsList.Exacta.length === 0) {
        setEmptyResult(4, "Exacta");
      } else {
        Result3.push(
          <div
            className="col"
            key={`Exacta-${resultsList.Exacta[0]?.PoolType}-${
              resultsList.Exacta[0]?.Position || 0
            }`}
          >
            {resultsExoticTable("Exacta", resultsList.Exacta)}
          </div>
        );
      }
    }

    if (raceInfo.DD2) {
      if (resultsList.Double && resultsList.Double.length === 0) {
        setEmptyResult(3, "Double");
      } else {
        Result3.push(
          <div
            className="col"
            key={`Double-${resultsList.Double[0]?.PoolType}-${resultsList.Double[0].Position}`}
          >
            {resultsExoticTable("Double", resultsList.Double)}
          </div>
        );
      }
    }

    if (raceInfo && raceInfo.Trifecta) {
      if (resultsList.Trifecta && resultsList.Trifecta.length === 0) {
        setEmptyResult(5, "Trifecta");
      } else {
        Result3.push(
          <div
            className="col"
            key={`Trifecta-${resultsList.Trifecta[0]?.PoolType}-${resultsList.Trifecta[0].Position}`}
          >
            {resultsExoticTable("Trifecta", resultsList.Trifecta)}
          </div>
        );
      }
    }

    if (raceInfo && raceInfo.Quinella) {
      if (resultsList.Quinella && resultsList.Quinella.length === 0) {
        setEmptyResult(6, "Quinella");
      } else {
        Result3.push(
          <div
            className="col"
            key={`Quinella-${resultsList.Quinella[0]?.PoolType}-${resultsList.Quinella[0].Position}`}
          >
            {resultsExoticTable("Quinella", resultsList.Quinella)}
          </div>
        );
      }
    }

    if (raceInfo && raceInfo.Omni) {
      if (resultsList.Omni && resultsList.Omni.length === 0) {
        setEmptyResult(19, "Omni");
      } else {
        Result3.push(
          <div className="col" key={resultsList.Omni[0]?.PoolType + "Omni"}>
            {resultsExoticTable("Omni", resultsList.Omni)}
          </div>
        );
      }
    }

    if (raceInfo && raceInfo.Superfecta) {
      if (resultsList.Superfecta && resultsList.Superfecta.length === 0) {
        setEmptyResult(7, "Superfecta");
      } else {
        Result3.push(
          <div
            className="col"
            key={resultsList.Superfecta[0]?.PoolType + "Superfecta"}
          >
            {resultsExoticTable("Superfecta", resultsList.Superfecta)}
          </div>
        );
      }
    }

    if (raceInfo.PP3) {
      if (resultsList.Pick3 && resultsList.Pick3.length === 0) {
        setEmptyResult(8, "Pick3");
      } else {
        Result3.push(
          <div className="col" key={resultsList.Pick3[0]?.PoolType + "Pick3"}>
            {resultsExoticTable("Pick3", resultsList.Pick3)}
          </div>
        );
      }
    }

    if (raceInfo.PP4) {
      if (resultsList.Pick4 && resultsList.Pick4.length === 0) {
        setEmptyResult(9, "Pick4");
      } else {
        Result3.push(
          <div className="col" key={resultsList.Pick4[0]?.PoolType + "Pick4"}>
            {resultsExoticTable("Pick4", resultsList.Pick4)}
          </div>
        );
      }
    }

    // TO DO: When the validation PP5 is ready, this if (if (resultsList.Pick5 && resultsList.Pick5.length !== 0)) must be deleted and the Result3.push remains inside the else
    if (raceInfo.PP5) {
      if (resultsList.Pick5 && resultsList.Pick5.length === 0) {
        setEmptyResult(11, "Pick5");
      } else {
        Result3.push(
          <div className="col" key={resultsList.Pick5[0]?.PoolType + "Pick5"}>
            {resultsExoticTable("Pick5", resultsList.Pick5)}
          </div>
        );
      }
    }

    if (raceInfo.PP6) {
      if (resultsList.Pick6 && resultsList.Pick6.length === 0) {
        setEmptyResult(10, "Pick6");
      } else {
        Result3.push(
          <div className="col" key={resultsList.Pick6[0]?.PoolType + "Pick6"}>
            {resultsExoticTable("Pick6", resultsList.Pick6)}
          </div>
        );
      }
    }

    // TO DO: When the validation PP7 is ready, this if (if (resultsList.Pick7 && resultsList.Pick7.length !== 0)) must be deleted and the Result3.push remains inside the else
    if (raceInfo.PP7) {
      if (resultsList.Pick7 && resultsList.Pick7.length === 0) {
        setEmptyResult(12, "Pick7");
      } else {
        Result3.push(
          <div className="col" key={resultsList.Pick7[0]?.PoolType + "Pick7"}>
            {resultsExoticTable("Pick7", resultsList.Pick7)}
          </div>
        );
      }
    }

    // TO DO: When the validation PP8 is ready, this if (if (resultsList.Pick8 && resultsList.Pick8.length !== 0)) must be deleted and the Result3.push remains inside the else
    if (raceInfo.PP8) {
      if (resultsList.Pick8 && resultsList.Pick8.length === 0) {
        setEmptyResult(13, "Pick8");
      } else {
        Result3.push(
          <div className="col" key={resultsList.Pick8[0]?.PoolType + "Pick8"}>
            {resultsExoticTable("Pick8", resultsList.Pick8)}
          </div>
        );
      }
    }

    // TO DO: When the validation PP9 is ready, this if (if (resultsList.Pick9 && resultsList.Pick9.length !== 0)) must be deleted and the Result3.push remains inside the else
    if (raceInfo.PP9) {
      if (resultsList.Pick9 && resultsList.Pick9.length === 0) {
        setEmptyResult(14, "Pick9");
      } else {
        Result3.push(
          <div className="col" key={resultsList.Pick9[0]?.PoolType + "Pick9"}>
            {resultsExoticTable("Pick9", resultsList.Pick9)}
          </div>
        );
      }
    }

    //TO DO: When the validation PP10 is ready, this if (if (resultsList.Pick10 && resultsList.Pick10.length !== 0)) must be deleted and the Result3.push remains inside the else
    if (raceInfo.PP10) {
      if (resultsList.Pick10 && resultsList.Pick10.length === 0) {
        setEmptyResult(16, "Pick10");
      } else {
        Result3.push(
          <div className="col" key={resultsList.Pick10[0]?.PoolType + "Pick10"}>
            {resultsExoticTable("Pick10", resultsList.Pick10)}
          </div>
        );
      }
    }

    // TO DO: When the validation PP11 is ready, this if (if (resultsList.Pick11 && resultsList.Pick11.length !== 0)) must be deleted and the Result3.push remains inside the else
    if (raceInfo.PP11) {
      if (resultsList.Pick11 && resultsList.Pick11.length === 0) {
        setEmptyResult(17, "Pick11");
      } else {
        Result3.push(
          <div className="col" key={resultsList.Pick11[0]?.PoolType + "Pick11"}>
            {resultsExoticTable("Pick11", resultsList.Pick11)}
          </div>
        );
      }
    }

    // TO DO: When the validation PP12 is ready, this if (if (resultsList.Pick12 && resultsList.Pick12.length !== 0)) must be deleted and the Result3.push remains inside the else
    if (raceInfo.PP12) {
      if (resultsList.Pick12 && resultsList.Pick12.length === 0) {
        setEmptyResult(18, "Pick12");
      } else {
        Result3.push(
          <div className="col" key={resultsList.Pick12[0]?.PoolType + "Pick12"}>
            {resultsExoticTable("Pick12", resultsList.Pick12)}
          </div>
        );
      }
    }
  }

  //EXOTIC TABLE READ ONLY
  if (raceInfo && readOnlyResults.length !== 0) {
    if (raceInfo.Exacta) {
      if (readOnlyResults.Exacta && readOnlyResults.Exacta.length !== 0) {
        ResultExoticView.push(
          <div
            className="col"
            key={`Exacta-${readOnlyResults.Exacta.PoolType}-${readOnlyResults.Exacta.Position}`}
          >
            {resultsExoticTable("Exacta", readOnlyResults.Exacta)}
          </div>
        );
      }
    }

    if (raceInfo.Trifecta) {
      if (readOnlyResults.Trifecta && readOnlyResults.Trifecta.length !== 0) {
        ResultExoticView.push(
          <div
            className="col"
            key={`Trifecta-${readOnlyResults.Trifecta.PoolType}-${readOnlyResults.Trifecta.Position}`}
          >
            {resultsExoticTable("Trifecta", readOnlyResults.Trifecta)}
          </div>
        );
      }
    }

    if (raceInfo.Superfecta) {
      if (
        readOnlyResults.Superfecta &&
        readOnlyResults.Superfecta.length !== 0
      ) {
        ResultExoticView.push(
          <div className="col" key={7 + "superfecta"}>
            {resultsExoticTable("Superfecta", readOnlyResults.Superfecta)}
          </div>
        );
      }
    }

    if (raceInfo.DD2) {
      if (readOnlyResults.Double && readOnlyResults.Double.length !== 0) {
        ResultExoticView.push(
          <div className="col" key={3 + "double"}>
            {resultsExoticTable("Double", readOnlyResults.Double)}
          </div>
        );
      }
    }

    if (raceInfo.Quinella) {
      if (readOnlyResults.Quinella && readOnlyResults.Quinella.length !== 0) {
        ResultExoticView.push(
          <div className="col" key={6 + "quinella"}>
            {resultsExoticTable("Quinella", readOnlyResults.Quinella)}
          </div>
        );
      }
    }

    if (raceInfo.Omni) {
      if (readOnlyResults.Omni && readOnlyResults.Omni.length !== 0) {
        ResultExoticView.push(
          <div className="col" key={19 + "omni"}>
            {resultsExoticTable("Omni", readOnlyResults.Omni)}
          </div>
        );
      }
    }

    if (raceInfo.PP3) {
      if (readOnlyResults.Pick3 && readOnlyResults.Pick3.length !== 0) {
        ResultExoticView.push(
          <div className="col" key={readOnlyResults.Pick3.PoolType + "Pick3"}>
            {resultsExoticTable("Pick3", readOnlyResults.Pick3)}
          </div>
        );
      }
    }

    if (raceInfo.PP4) {
      if (readOnlyResults.Pick4 && readOnlyResults.Pick4.length !== 0) {
        ResultExoticView.push(
          <div className="col" key={readOnlyResults.Pick4.PoolType + "Pick4"}>
            {resultsExoticTable("Pick4", readOnlyResults.Pick4)}
          </div>
        );
      }
    }

    if (readOnlyResults.Pick5 && readOnlyResults.Pick5.length !== 0) {
      ResultExoticView.push(
        <div className="col" key={readOnlyResults.Pick5.PoolType + "Pick5"}>
          {resultsExoticTable("Pick5", readOnlyResults.Pick5)}
        </div>
      );
    }

    if (readOnlyResults.Pick6 && readOnlyResults.Pick6.length !== 0) {
      ResultExoticView.push(
        <div className="col" key={readOnlyResults.Pick6.PoolType + "Pick6"}>
          {resultsExoticTable("Pick6", readOnlyResults.Pick6)}
        </div>
      );
    }

    if (readOnlyResults.Pick7 && readOnlyResults.Pick7.length !== 0) {
      ResultExoticView.push(
        <div className="col" key={readOnlyResults.Pick7.PoolType + "Pick7"}>
          {resultsExoticTable("Pick7", readOnlyResults.Pick7)}
        </div>
      );
    }

    if (readOnlyResults.Pick8 && readOnlyResults.Pick8.length !== 0) {
      ResultExoticView.push(
        <div className="col" key={readOnlyResults.Pick8.PoolType + "Pick8"}>
          {resultsExoticTable("Pick8", readOnlyResults.Pick8)}
        </div>
      );
    }

    if (readOnlyResults.Pick9 && readOnlyResults.Pick9.length !== 0) {
      ResultExoticView.push(
        <div className="col" key={readOnlyResults.Pick9.PoolType + "Pick9"}>
          {resultsExoticTable("Pick9", readOnlyResults.Pick9)}
        </div>
      );
    }

    if (readOnlyResults.Pick10 && readOnlyResults.Pick10.length !== 0) {
      ResultExoticView.push(
        <div className="col" key={readOnlyResults.Pick10.PoolType + "Pick10"}>
          {resultsExoticTable("Pick10", readOnlyResults.Pick10)}
        </div>
      );
    }

    if (readOnlyResults.Pick11 && readOnlyResults.Pick11.length !== 0) {
      ResultExoticView.push(
        <div className="col" key={readOnlyResults.Pick11.PoolType + "Pick11"}>
          {resultsExoticTable("Pick11", readOnlyResults.Pick11)}
        </div>
      );
    }

    if (readOnlyResults.Pick12 && readOnlyResults.Pick12.length !== 0) {
      ResultExoticView.push(
        <div className="col" key={readOnlyResults.Pick12.PoolType + "Pick12"}>
          {resultsExoticTable("Pick12", readOnlyResults.Pick12)}
        </div>
      );
    }
  }

  //Función del botón Save Results
  const handleSaveResults = (resultsR, OfficialR) => {
    let results = [];
    let oneResult = {},
      offTime;
    setErrorsPTF(false);
    let errorMessage = [];

    resultsList.Exacta &&
      resultsList.Exacta.forEach((item) => {
        if (item.Selections !== "" || item.Payout !== "") {
          let payout = item.Payout;
          if (payout === "") {
            payout = 0;
          }
          results.push({ ...item, RaceID: raceSelected, Payout: payout });
        }
      });

    resultsList.Double &&
      resultsList.Double.forEach((item) => {
        if (item.Selections !== "" || item.Payout !== "") {
          let payout = item.Payout;
          if (payout === "") {
            payout = 0;
          }
          results.push({
            ...item,
            RaceID: raceSelected,
            Payout: payout,
          });
        }
      });

    let ptf;
    resultsList.Pick3 &&
      resultsList.Pick3.forEach((item) => {
        if (item.Selections !== "" || item.Payout !== "") {
          if (item.PTF !== "") {
            ptf = item.PTF.replace(/\s/g, "");
          } else {
            ptf = "";
          }

          let payout = item.Payout;
          if (payout === "") {
            payout = 0;
          }
          results.push({
            ...item,
            RaceID: raceSelected,
            PTF: ptf,
            Payout: payout,
          });
        }
        if (item.PTF) {
          const ptfSplit = item.PTF.replace(/\s/g, "").split("-");

          // Check if there is at least one digit in each part.
          const errorPtf = ptfSplit.some((space, index) => {
            return !/\d/.test(space);
          });

          if (errorPtf) {
            errorMessage.push(`Pick3: PTF data are not valid.`);
          }
        }
      });

    resultsList.Pick4 &&
      resultsList.Pick4.forEach((item) => {
        if (item.Selections !== "" || item.Payout !== "") {
          let payout = item.Payout;
          if (payout === "") {
            payout = 0;
          }
          results.push({
            ...item,
            RaceID: raceSelected,
            PTF: item.PTF.replace(/\s/g, ""),
            Payout: payout,
          });
        }
        if (item.PTF) {
          const ptfSplit = item.PTF.replace(/\s/g, "").split("-");

          // Check for at least one digit in each space
          const errorPtf = ptfSplit.some((space, index) => {
            return !/\d/.test(space);
          });

          if (errorPtf) {
            errorMessage.push(`Pick4: PTF data are not valid.`);
          }
        }
      });

    resultsList.Pick5 &&
      resultsList.Pick5.forEach((item) => {
        if (item.Selections !== "" || item.Payout !== "") {
          let payout = item.Payout;
          if (payout === "") {
            payout = 0;
          }
          results.push({
            ...item,
            RaceID: raceSelected,
            PTF: item.PTF.replace(/\s/g, ""),
            Payout: payout,
          });
        }
        if (item.PTF) {
          const ptfSplit = item.PTF.replace(/\s/g, "").split("-");

          // Check for at least one digit in each space
          const errorPtf = ptfSplit.some((space, index) => {
            return !/\d/.test(space);
          });

          if (errorPtf) {
            errorMessage.push(`Pick5: PTF data are not valid.`);
          }
        }
      });

    resultsList.Pick6 &&
      resultsList.Pick6.forEach((item) => {
        if (item.Selections !== "" || item.Payout !== "") {
          let payout = item.Payout;
          if (payout === "") {
            payout = 0;
          }
          results.push({
            ...item,
            RaceID: raceSelected,
            PTF: item.PTF.replace(/\s/g, ""),
            Payout: payout,
          });
        }
        if (item.PTF) {
          const ptfSplit = item.PTF.replace(/\s/g, "").split("-");

          // Check for at least one digit in each space
          const errorPtf = ptfSplit.some((space, index) => {
            return !/\d/.test(space);
          });

          if (errorPtf) {
            errorMessage.push(`Pick6: PTF data are not valid.`);
          }
        }
      });

    resultsList.Pick7 &&
      resultsList.Pick7.forEach((item) => {
        if (item.Selections !== "" || item.Payout !== "") {
          let payout = item.Payout;
          if (payout === "") {
            payout = 0;
          }
          results.push({
            ...item,
            RaceID: raceSelected,
            PTF: item.PTF.replace(/\s/g, ""),
            Payout: payout,
          });
        }
        if (item.PTF) {
          const ptfSplit = item.PTF.replace(/\s/g, "").split("-");

          // Check for at least one digit in each space
          const errorPtf = ptfSplit.some((space, index) => {
            return !/\d/.test(space);
          });

          if (errorPtf) {
            errorMessage.push(`Pick7: PTF data are not valid.`);
          }
        }
      });

    resultsList.Pick8 &&
      resultsList.Pick8.forEach((item) => {
        if (item.Selections !== "" || item.Payout !== "") {
          let payout = item.Payout;
          if (payout === "") {
            payout = 0;
          }
          results.push({
            ...item,
            RaceID: raceSelected,
            PTF: item.PTF.replace(/\s/g, ""),
            Payout: payout,
          });
        }
        if (item.PTF) {
          const ptfSplit = item.PTF.replace(/\s/g, "").split("-");

          // Check for at least one digit in each space
          const errorPtf = ptfSplit.some((space, index) => {
            return !/\d/.test(space);
          });

          if (errorPtf) {
            errorMessage.push(`Pick8: PTF data are not valid.`);
          }
        }
      });

    resultsList.Pick9 &&
      resultsList.Pick9.forEach((item) => {
        if (item.Selections !== "" || item.Payout !== "") {
          let payout = item.Payout;
          if (payout === "") {
            payout = 0;
          }
          results.push({
            ...item,
            RaceID: raceSelected,
            PTF: item.PTF.replace(/\s/g, ""),
            Payout: payout,
          });
        }
        if (item.PTF) {
          const ptfSplit = item.PTF.replace(/\s/g, "").split("-");

          // Check for at least one digit in each space
          const errorPtf = ptfSplit.some((space, index) => {
            return !/\d/.test(space);
          });

          if (errorPtf) {
            errorMessage.push(`Pick9: PTF data are not valid.`);
          }
        }
      });

    resultsList.Pick10 &&
      resultsList.Pick10.forEach((item) => {
        if (item.Selections !== "" || item.Payout !== "") {
          let payout = item.Payout;
          if (payout === "") {
            payout = 0;
          }
          results.push({
            ...item,
            RaceID: raceSelected,
            PTF: item.PTF.replace(/\s/g, ""),
            Payout: payout,
          });
        }
        if (item.PTF) {
          const ptfSplit = item.PTF.replace(/\s/g, "").split("-");

          // Check for at least one digit in each space
          const errorPtf = ptfSplit.some((space, index) => {
            return !/\d/.test(space);
          });

          if (errorPtf) {
            errorMessage.push(`Pick10: PTF data are not valid.`);
          }
        }
      });

    resultsList.Pick11 &&
      resultsList.Pick11.forEach((item) => {
        if (item.Selections !== "" || item.Payout !== "") {
          let payout = item.Payout;
          if (payout === "") {
            payout = 0;
          }
          results.push({
            ...item,
            RaceID: raceSelected,
            PTF: item.PTF.replace(/\s/g, ""),
            Payout: payout,
          });
        }
        if (item.PTF) {
          const ptfSplit = item.PTF.replace(/\s/g, "").split("-");

          // Check for at least one digit in each space
          const errorPtf = ptfSplit.some((space, index) => {
            return !/\d/.test(space);
          });

          if (errorPtf) {
            errorMessage.push(`Pick11: PTF data are not valid.`);
          }
        }
      });

    resultsList.Pick12 &&
      resultsList.Pick12.forEach((item) => {
        if (item.Selections !== "" || item.Payout !== "") {
          let payout = item.Payout;
          if (payout === "") {
            payout = 0;
          }
          results.push({
            ...item,
            RaceID: raceSelected,
            PTF: item.PTF.replace(/\s/g, ""),
            Payout: payout,
          });
        }
        if (item.PTF) {
          const ptfSplit = item.PTF.replace(/\s/g, "").split("-");

          // Check for at least one digit in each space
          const errorPtf = ptfSplit.some((space, index) => {
            return !/\d/.test(space);
          });

          if (errorPtf) {
            errorMessage.push(`Pick12: PTF data are not valid.`);
          }
        }
      });

    resultsList.Superfecta &&
      resultsList.Superfecta.forEach((item) => {
        if (item.Selections !== "" || item.Payout !== "") {
          let payout = item.Payout;
          if (payout === "") {
            payout = 0;
          }
          results.push({ ...item, RaceID: raceSelected, Payout: payout });
        }
      });

    resultsList.Trifecta &&
      resultsList.Trifecta.forEach((item) => {
        if (item.Selections !== "" || item.Payout !== "") {
          let payout = item.Payout;
          if (payout === "") {
            payout = 0;
          }
          results.push({ ...item, RaceID: raceSelected, Payout: payout });
        }
      });

    resultsList.Quinella &&
      resultsList.Quinella.forEach((item) => {
        if (item.Selections !== "" || item.Payout !== "") {
          let payout = item.Payout;
          if (payout === "") {
            payout = 0;
          }
          results.push({ ...item, RaceID: raceSelected, Payout: payout });
        }
      });

    resultsList.Grandslam &&
      resultsList.Grandslam.forEach((item) => {
        if (item.Selections !== "" || item.Payout !== "") {
          let payout = item.Payout;
          if (payout === "") {
            payout = 0;
          }
          results.push({ ...item, RaceID: raceSelected, Payout: payout });
        }
      });

    resultsList.Omni &&
      resultsList.Omni.forEach((item) => {
        if (item.Selections !== "" || item.Payout !== "") {
          let payout = item.Payout;
          if (payout === "") {
            payout = 0;
          }
          results.push({ ...item, RaceID: raceSelected, Payout: payout });
        }
      });

    resultsList.WPSList.forEach((element) => {
      if (element.Win !== "") {
        oneResult = {};
        oneResult.PoolType = 0;
        oneResult.Selections = String(element.Entrynum);
        oneResult.Correct = 0;
        oneResult.Payout = element.Win;
        oneResult.RaceID = raceSelected;
        results.push(oneResult);
      }

      if (element.Place !== "") {
        oneResult = {};
        oneResult.PoolType = 1;
        oneResult.Selections = String(element.Entrynum);
        oneResult.Correct = 0;
        oneResult.Payout = element.Place;
        oneResult.RaceID = raceSelected;
        results.push(oneResult);
      }

      if (element.Show !== "") {
        oneResult = {};
        oneResult.PoolType = 2;
        oneResult.Selections = String(element.Entrynum);
        oneResult.Correct = 0;
        oneResult.Payout = element.Show;
        oneResult.RaceID = raceSelected;
        results.push(oneResult);
      }
    });

    if (errorMessage.length !== 0) {
      setErrorsPTF(true);
    }
    if (errorMessage.length === 0 && !errorsPTF) {
      if (results.length < 1) {
        Swal.fire({
          icon: "error",
          title: "No results",
          text: "Something went wrong!",
        });
      } else if (!raceInfo.OffTime && raceInfo.RaceStatus !== "X") {
        Swal.fire({
          icon: "error",
          title: "Upss!",
          text: "Off Time is required",
        });
      } else {
        if (OfficialR) {
          if (raceInfo.OffTime === "" && raceInfo.RaceStatus === "X") {
            offTime = raceInfo.PostTime;
          } else {
            offTime = raceInfo.OffTime;
          }
          //SAVE RESULTS
          ConfirmDialog(`Changes will be saved!`).then(async (result) => {
            if (result.isConfirmed) {
              const res = await updateResultsInfo(
                {
                  Results: results,
                  UserID: userInfo.IdUser,
                  TrackCode: trackCode,
                  OffTime: offTime,
                },
                userInfo.LogonSessionID
              );

              if (res?.error) {
                if (
                  res.Result === ErrorCodes.InvalidSession ||
                  res.Result === ErrorCodes.SessionNoLongerExists
                ) {
                  setSessionNoLongerExists(true);
                }
                return;
              } else {
                successMsg("Save Results");
              }
            }
          });
        }
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Ups!",
        html: errorMessage.join("<br/>"),
        showConfirmButton: true,
      });
      setErrorsPTF(false);
    }
  };

  //Botones Save Results
  buttonsResults = (
    <div>
      <button
        type="button"
        className="btn btn-info"
        onClick={() => handleSaveResults(resultsList, true)}
      >
        Save Results
      </button>
    </div>
  );

  //Onchange tabla Results
  const resultsTableChangeHandler = (event) => {
    let numEntryR = 0,
      eventEntry = event.target.value,
      entryName;

    if (event.target.name === "Entrynum" && event.target.value !== "") {
      entries.forEach((item) => {
        if (item.EntryNum === event.target.value) {
          if (item.FinishPos === -1) {
            eventEntry = "";
          }
          numEntryR++;
        }
      });

      if (numEntryR >= 2) {
        eventEntry = event.target.value;
      }
      eventEntry = parseInt(event.target.value);

      entries.forEach((track) => {
        if (track.EntryNum === eventEntry) {
          entryName = track.EntryName;
        }
      });
    }

    const x = { ...resultsList };
    let name = event.target.name;
    let key = event.target.getAttribute("data-key");
    let value = eventEntry;
    if (event.target.name === "Entrynum") {
      x.WPSList[key]["Entryname"] = entryName;
    }
    x.WPSList[key][name] = value;

    setResultsList(x);
  };

  //SETEAR RESULTS
  let tableResults = [],
    resultsListWP = [],
    oneResults = {},
    resultList = [];

  if (resultsList.WPSList) {
    resultsList.WPSList.forEach((item, index) => {
      resultList = [];
      oneResults = {};
      switch (item["Pos"]) {
        case 1:
          oneResults.Pos = item["Pos"] + "st";
          break;
        case 2:
          oneResults.Pos = item["Pos"] + "nd";
          break;
        case 3:
          oneResults.Pos = item["Pos"] + "rd";
          break;
        default:
          oneResults.Pos = item["Pos"].toString();
      }
      oneResults.EntryNum = item["Entrynum"].toString();

      oneResults.EntryName = item["Entryname"];
      resultList.push(
        <td key={1}>
          <h5>
            <span>{item["Entryname"]}</span>
          </h5>
        </td>
      );

      oneResults.Win = item["Win"];
      oneResults.Place = item["Place"];
      oneResults.Show = item["Show"];

      if (item["Win"] === "0") {
        oneResults.Win = "";
      }
      if (item["Place"] === "0") {
        oneResults.Place = "";
      }
      if (item["Show"] === "0") {
        oneResults.Show = "";
      }

      resultsListWP.push(oneResults);
    });
  }

  if (resultsListWP) {
    tableResults = resultsListWP.map((data, i) => {
      return (
        <tr key={i}>
          <td
            style={{
              textAlign: "center",
              width: "20px",
              verticalAlign: "middle",
            }}
          >
            {data.Pos}
          </td>
          <td
            style={{
              textAlign: "center",
              verticalAlign: "middle",
              width: "80px",
            }}
          >
            {insertOrViewResults ? (
              <select
                name="Entrynum"
                data-key={i}
                className="form-control"
                onChange={resultsTableChangeHandler}
                value={data.EntryNum || ""}
              >
                <option value="" disabled hidden>
                  {data.EntryNum === "" && ""}
                </option>
                {filteredEntries.map((item) => {
                  const entryExists = resultsListWP.some(
                    (entry) => entry.EntryNum === item.EntryNum.toString()
                  );

                  if (
                    (!entryExists ||
                      data.EntryNum === item.EntryNum.toString()) &&
                    (data.EntryNum !== "" || item.EntryNum !== "1")
                  ) {
                    return (
                      <option key={item.EntryID} value={item.EntryNum}>
                        {item.EntryNum}
                      </option>
                    );
                  }

                  return null;
                })}
              </select>
            ) : (
              data.EntryNum
            )}
          </td>
          <td>
            <input
              className="form-control results-font"
              type="text"
              autoComplete="off"
              name="EntryName"
              data-key={i}
              value={data.EntryName || ""}
              onChange={resultsTableChangeHandler}
              style={{
                backgroundColor: "transparent",
                border: "none",
                textAlign: "center",
              }}
              disabled
            />
          </td>
          <td>
            {insertOrViewResults ? (
              <input
                className="form-control results-font font-weight-bolder"
                type="number"
                autoComplete="off"
                name="Win"
                data-key={i}
                value={data.Win || ""}
                onChange={resultsTableChangeHandler}
                style={{
                  backgroundColor: "transparent",
                  border: "none",
                  textAlign: "center",
                }}
              />
            ) : (
              <div className="mt-1" style={{ textAlign: "center" }}>
                {data.Win || ""}
              </div>
            )}
          </td>
          <td>
            {insertOrViewResults ? (
              <input
                className="form-control results-font font-weight-bolder"
                type="number"
                autoComplete="off"
                name="Place"
                data-key={i}
                value={data.Place || ""}
                onChange={resultsTableChangeHandler}
                style={{
                  backgroundColor: "transparent",
                  border: "none",
                  textAlign: "center",
                }}
              />
            ) : (
              <div className="mt-1" style={{ textAlign: "center" }}>
                {data.Place || ""}
              </div>
            )}
          </td>
          <td>
            {insertOrViewResults ? (
              <input
                className="form-control results-font font-weight-bolder"
                type="number"
                autoComplete="off"
                name="Show"
                data-key={i}
                value={data.Show || ""}
                onChange={resultsTableChangeHandler}
                style={{
                  backgroundColor: "transparent",
                  border: "none",
                  textAlign: "center",
                }}
              />
            ) : (
              <div className="mt-1" style={{ textAlign: "center" }}>
                {data.Show || ""}
              </div>
            )}
          </td>
        </tr>
      );
    });
  }

  if (insertOrViewResults) {
    insertOrViewResultsBtn = (
      <div>
        <button
          type="button"
          className="btn btn-info"
          onClick={() => setInsertOrViewResults(false)}
        >
          View Results
        </button>
      </div>
    );
  } else {
    insertOrViewResultsBtn = (
      <div>
        <button
          type="button"
          className="btn btn-success"
          onClick={() => setInsertOrViewResults(true)}
        >
          Insert Results
        </button>
      </div>
    );
  }

  return (
    <>
      {!isDisabled && (
        <div style={{ textAlign: "right" }}> {insertOrViewResultsBtn}</div>
      )}
      <div style={{ textAlign: "center" }}>
        <h5>
          <span>
            <img src="../images/results.png" alt="" className="mb-2 mr-2" />
          </span>
          <span
            style={{
              color: "#1cc8e3",
              fontWeight: "bold",
            }}
          >
            R{raceInfo.RaceNumber}{" "}
          </span>
          <span style={{ color: "#808080", fontWeight: "bold" }}>Results</span>
        </h5>
      </div>
      {insertOrViewResults ? (
        <>
          <table className="table table-striped table-md">
            <thead className="thead-dark">
              <tr className="text-center">
                <th hidden>RaceID</th>
                <th>POS</th>
                <th>#</th>
                <th>Entry Name</th>
                <th>Win</th>
                <th>Place</th>
                <th>Show</th>
              </tr>
            </thead>
            <tbody className="table-sm">{tableResults}</tbody>
          </table>
          {Result3}
          <div style={{ textAlign: "right" }}>{buttonsResults}</div>{" "}
        </>
      ) : (
        <>
          <table className="table table-striped table-md">
            <thead className="thead-dark">
              <tr className="text-center">
                <th hidden>RaceID</th>
                <th>POS</th>
                <th>#</th>
                <th>Entry Name</th>
                <th>Win</th>
                <th>Place</th>
                <th>Show</th>
              </tr>
            </thead>
            <tbody className="table-sm">{tableResults}</tbody>
          </table>
          {ResultExoticView}
        </>
      )}
    </>
  );
};

export default Results;
